import localeLogin from '@/views/login/locale/zh-CN';
import localeHome from '@/views/down/locale/zh-CN';

import localeSettings from './zh-CN/settings';

export default {
  'menu.required': '请填写所有必填项',
  'menu.personal': '个人用户',
  'menu.locale': '简体中文',
  'menu.dark': '黑色模式',
  'menu.overview': '总览',
  'menu.accountsecurity': '账户安全',
  'menu.identityauthentication': '身份认证',
  'menu.paymentmethod': '收款方式',
  'menu.fundmanagement': '资金管理',
  'menu.balance': '余额',
  'menu.recharge': '充值',
  'menu.buycoins': '买币',
  'menu.transferaccounts': '转账',
  'menu.withdrawal': '提现',
  'menu.recordquery': '记录查询',
  'menu.c2corder': 'C2C订单',
  'menu.payhis': 'PAY历史交易',
  'menu.wallethistory': '钱包历史记录',
  'menu.setupp': '设置',
  'menu.loginOut': '退出登录',
  'navbar.action.locale': '切换为简体中文',
  'public.next': '下一步',
  'public.submit': '提交',
  ...localeSettings,
  ...localeLogin,
  ...localeHome,
};
